import parse from "html-react-parser";

export const parseHtmlGetBody = (html: string) => {
    return getBody(parse(html || ""));
};

export const getBody = (
    node: string | React.DetailedReactHTMLElement<{}, HTMLElement> | React.DetailedReactHTMLElement<{}, HTMLElement>[],
    subCall?: boolean,
) => {
    if (typeof node === "object") {
        if ("type" in node && node.type === "body") {
            return "children" in node.props ? node.props.children : false;
        }

        if (!subCall && (("type" in node && node.type !== "html") || !("type" in node))) {
            return node;
        }
        if (
            "props" in node &&
            "children" in node.props &&
            node.props.children != null &&
            (node.props.children as any)?.length > 0
        ) {
            let returnValue: any = false;
            if ((node.props.children as any)?.forEach) {
                (node.props.children as any)?.forEach(
                    (
                        child:
                            | React.DetailedReactHTMLElement<{ children: any }, HTMLElement>
                            | React.DetailedReactHTMLElement<{}, HTMLElement>[],
                    ) => {
                        const bodyContent = getBody(child, true);
                        if (bodyContent) {
                            returnValue = bodyContent;
                        }
                    },
                );
            }
            return returnValue;
        }
        return false;
    }
    return false;
};
